module.exports = __webpack_public_path__ + "img/sit.aeacacf3.png";